import { render, staticRenderFns } from "./ShopRenew.vue?vue&type=template&id=31683c8c&scoped=true&"
import script from "./ShopRenew.vue?vue&type=script&lang=js&"
export * from "./ShopRenew.vue?vue&type=script&lang=js&"
import style0 from "./ShopRenew.vue?vue&type=style&index=0&id=31683c8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31683c8c",
  null
  
)

export default component.exports